import { render, staticRenderFns } from "./MobileApp.vue?vue&type=template&id=263f6622"
import script from "./MobileApp.vue?vue&type=script&lang=js"
export * from "./MobileApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263f6622')) {
      api.createRecord('263f6622', component.options)
    } else {
      api.reload('263f6622', component.options)
    }
    module.hot.accept("./MobileApp.vue?vue&type=template&id=263f6622", function () {
      api.rerender('263f6622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/MobileApp.vue"
export default component.exports